module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.10938/img/templates-homepage/stand-out-icon.svg"